import { TOMCAT } from "./setup";
export const WEB_ID = "kutxabank.cms";
export const TITLE = "Kutxabank &#8211; &#8211; Venta de entradas";
export const BASE_URL = `https://firestore.googleapis.com/v1/projects/jmdb-production/databases/(default)/documents/webitems`;
export const ENV = "pro";
export const C = "9999999800";
export const COLORES = {
  marca: "#0CB7F2",
  extra: "#004B6C",
  oscuro: "#1d1d1b",
  claro: "#E6E6E6",
  fondo: "#FFFFFF",
  pie: "#E6E6E6",
};
export const DOC_BASE = `https://firestore.googleapis.com/v1/projects/jmdb-production/databases/(default)/documents`;
export const OPERACIONES =
  "https://tickets.janto.es/teuticket/public/janto/main.php?Nivel=MisOperaciones&modo=IFRAME";
export const COMPRAR =
  "https://tickets.janto.es/teuticket/public/janto/main.php?Nivel=comoFunciona&modo=IFRAME";
export const IDIOMAS = ["eu", "es", "en", "fr"];

export const LOGO =
  "https://firebasestorage.googleapis.com/v0/b/jmdb-production.appspot.com/o/establecimientos%2Fextras%2Fextras%2FZOZR36HN84K%2FfvZOZR36HN84K%40_UrlIAE__fichero-iae.png?alt=media";
export const CONTEXTO = ENV == "pro" ? "Janto_KB" : "Janto_DES";
export const GRAPHQL_URL = "https://cmspre.janto.es:8443/graphql";
const RUTA =
  ENV == "pro"
    ? `${TOMCAT[CONTEXTO]}`
    : "https://tomcatdesarrollos.janto.es:8443";
export const DEFAULT_IMG = {
  banner:
    "https://firebasestorage.googleapis.com/v0/b/jmdb-production.appspot.com/o/webs%2Fteuticket%2Fbanner.jpg?alt=media",
  cuadrado:
    "https://firebasestorage.googleapis.com/v0/b/jmdb-production.appspot.com/o/webs%2Fteuticket%2Fcuadrado.jpg?alt=media",
  vertical:
    "https://firebasestorage.googleapis.com/v0/b/jmdb-production.appspot.com/o/webs%2Fteuticket%2Fvertical.jpg?alt=media",
  poster:
    "https://firebasestorage.googleapis.com/v0/b/jmdb-production.appspot.com/o/webs%2Fteuticket%2Fposter.jpg?alt=media",
  destacados:
    "https://firebasestorage.googleapis.com/v0/b/jmdb-production.appspot.com/o/webs%2Fteuticket%2Fdestacados.jpg?alt=media",
  fondo:
    "https://firebasestorage.googleapis.com/v0/b/jmdb-production.appspot.com/o/webs%2Fteuticket%2Ffondo.jpg?alt=media",
};
export const WEB_URL = `https://firestore.googleapis.com/v1/projects/jmdb-production/databases/(default)/documents/webitems/${WEB_ID}`;
// .collection('literales').doc('locale')
// export const LITERALES_URL = `https://firestore.googleapis.com/v1/projects/jmdb-production/databases/(default)/documents/webitems/${WEB_ID}/literales/locale`
export const LITERALES_URL = `https://firestore.googleapis.com/v1/projects/jmdb-production/databases/(default)/documents/literales/${WEB_ID}`;
export const EVENTOSWEB = `
query getEventosWeb {
  getEventosWeb(web:"${WEB_ID}" ) {
    Instalaciones {
      Instalacion
      Eventos {
        Abono
        AliasCalif
        Calificacion
        Desc1
        Desc2
        DescTemporada
        Duracion
        Estreno
        FFinVentaMax
        FInicioVentaMin
        FSesionMax
        FSesionMin
        FechaUltimoUso
        Id
        IdInfoAdicional
        IdJMDB
        Impuesto
        ImpuestoComision
        InfoTicket1
        InfoTicket2
        InfoTicket3
        InfoTicket4
        InfoTicket5
        InfoTicket6
        LM
        LogoTicket
        MaxPrecioBase
        MinPrecioBase
        ModoMuseo
        Nombre
        NumSesiones
        Ranking
        RegistroWeb
        Temporada
        TipoFicha
        TktTitulo
        TopVentas
        UrlCartel
        UsarCalendario
        VerFecha
        VerHora
        VersionImg
        VersionInfo
        VersionInfoObligada
        Provincia {
          Nombre
          ProvinciaINE
          Id
        }
        Poblacion {
          Nombre
          PoblacionINE
          Id
        }
        Tipo {
          Nombre
          Imagen
          IdMasterTipoE
          Codigo
        }
        Recinto {
          Nombre
          Id
          Imagen
          Direccion
          CP
        }
      }
    }
  }
}
`;
export const SESIONES = `
            query getQservlet {
              getQservlet(IdCookie:"${C}", Contexto:"${CONTEXTO}", Nivel:"Sesiones"){
                Nombre
                Id
                IdJMDB
                NumSesiones
                Recinto{
                  Id
                  Nombre
                }
                Sesiones{
                  IdSesion
                  Abono
                  Nombre
                  Promotor
                  NombreSala
                  Numerada
                  TieneEtiquetas
                  InicioVenta
                  VentaCombinada
                  Disponible
                  Agotado
                  InfoTicket1
                  FinVenta
                  HoraSes
                  MinPrecioBase
                  VerFecha
                  VerHora
                  MaxPrecioBase
                  InfoRecSes1
                  InfoEvSes1
                  InfoTicket2
                  OrdenSesion
                  UrlVentaExterna
                  

                  
            
                }
                Poblacion {
                  Nombre
                },
                Provincia {
                  Nombre
                }
                Tipo{
                  Nombre
                }
            
              }
            }
            `;
export default {
  WEB_URL,
  RUTA,
  CONTEXTO,
  LITERALES_URL,
  DEFAULT_IMG,
};
